import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getContactServiceList, getDeviceAccess, getWishList, partnerApi, vendorDashboard , partnerCategory } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import {
  Collapse, CardBody, Card, CardHeader, Modal, ModalBody, Row, Col, ModalFooter, ModalHeader
} from 'reactstrap';

import Tabs from "../Tabs";

import TabsPane from "../Tabs/TabsPane";

import DataTable from 'react-data-table-component';

import YourArticles from './articles/yourarticles';
import UploadArticle from './articles/uploadyourarticle';
import BeWiseArticles from './articles/bewisearticles';


const childTabs = [
    {
        name: "Your Articles",
        id: "yourarticle",
        defaultChecked: true,
    },
    {
        name: "Upload Your Article",
        id: "uploadyourarticle",
    },
    {
        name: "BeWise Articles",
        id: "bewisearticles",
    }
];

class partnerArticles extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
    }
 
  }

  componentDidMount() {
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  render() {
 

 
        return (
            <React.Fragment>
                <AdminLayout>
                    
                       <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Articles</h4>
                    
                        <Tabs tabsetName="dashboard" childTabs={childTabs}>
                                    <TabsPane id="yourarticles">
                                        <YourArticles />
                                    </TabsPane>
                                    <TabsPane id="uploadyourarticle">
                                        <UploadArticle />
                                    </TabsPane>
                                    <TabsPane id="bewisearticles">
                                        <BeWiseArticles />
                                    </TabsPane>
                        </Tabs>
                   
                </div>
              </div>
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default partnerArticles;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/articles.jsx